var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import config from '../config';
import levels from './levels';
function log(logFunction, messages, minLevel) {
    if (config().logLevel <= minLevel) {
        logFunction.apply(console, __spreadArrays(['[AwsUi] '], messages));
    }
}
export var alreadyLoggedOnce = {
    info: {},
    warn: {}
};
function checkAlreadyLogged(store) {
    var messages = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        messages[_i - 1] = arguments[_i];
    }
    var key = messages.join(' ');
    if (store[key]) {
        return true;
    }
    store[key] = true;
    return false;
}
var logger = {
    levels: levels,
    info: function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        log(console.log, messages, levels.INFO);
    },
    warn: function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        log(console.warn, messages, levels.WARN);
    },
    error: function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        if (config().production) {
            log(console.error, messages, levels.ERROR);
        }
        else {
            var stringifiedMessages = messages.map(function (message) {
                return typeof message === 'string' ? message : JSON.stringify(message);
            });
            throw new Error(stringifiedMessages.join(' '));
        }
    },
    infoOnce: function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        if (checkAlreadyLogged.apply(void 0, __spreadArrays([alreadyLoggedOnce.info], messages))) {
            return;
        }
        logger.info.apply(logger, messages);
    },
    warnOnce: function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        if (checkAlreadyLogged.apply(void 0, __spreadArrays([alreadyLoggedOnce.warn], messages))) {
            return;
        }
        logger.warn.apply(logger, messages);
    }
};
export default logger;
//# sourceMappingURL=index.js.map